module.exports = __webpack_public_path__ + "img/plenty.f09af317.png";